module.exports = __webpack_public_path__ + "static/media/i5.9769d4ec.jpg";